import React from 'react';
import LegalLayout from '@/components/LegalLayout';

export default function PartnerTerms() {
  return (
    <LegalLayout title="Partner Terms" testId="partner-terms-page">
      <p>
        These Partner Terms apply to anyone using BeautyMateUK as a service
        Partner. They are in addition to our Terms & Conditions and Privacy
        Policy.
      </p>

      <h2>1. Independent Partner Status</h2>
      <p>
        Partners use BeautyMateUK as independent self-employed service providers.
        Nothing in these Terms creates an employment relationship, worker
        relationship, agency employment relationship, partnership, joint venture,
        or relationship of employer and employee between BeautyMateUK and any
        Partner.
      </p>
      <p>
        Partners are free to decide whether to accept or reject booking requests,
        subject to these Terms and any customer commitments they choose to
        accept. Partners are responsible for their own tax, National Insurance,
        licences, registrations, insurance, tools, equipment, training,
        qualifications, and legal compliance.
      </p>
      <p>
        BeautyMateUK does not guarantee any minimum number of bookings, minimum
        earnings, working hours, or continuing work. Partners remain responsible
        for the manner in which they perform their services, provided that they
        comply with applicable law, customer safety rules, platform standards,
        and these Terms.
      </p>

      <h2>2. Permitted Booking Hours</h2>
      <p>
        BeautyMateUK only permits appointments to be booked and performed through
        the Platform between <strong>06:00 and 23:00 UK local time</strong>. The
        Platform will not knowingly accept or process bookings outside these
        hours. Any arrangement made between a Customer and a Partner outside the
        Platform, or outside the permitted booking hours, is not a BeautyMateUK
        booking and is not covered by BeautyMateUK support, booking protection,
        cancellation handling, payment processing, or dispute support. Partners
        must not encourage Customers to arrange off-platform or out-of-hours
        appointments. BeautyMateUK may suspend or remove any Partner who breaches
        this rule.
      </p>

      <h2>3. Off-Platform Bookings</h2>
      <p>
        Partners must not encourage, request, or accept off-platform bookings
        from Customers introduced through BeautyMateUK. Any attempt to bypass the
        Platform, avoid platform fees, or move a BeautyMateUK Customer to direct
        booking may result in suspension, removal, withholding of platform
        privileges, or other action permitted by law.
      </p>

      <h2>4. Documents and Verification</h2>
      <p>To go live, Partners must upload:</p>
      <ul>
        <li>Photo ID</li>
        <li>Right-to-work document or GOV.UK share code</li>
        <li>Qualification certificate</li>
        <li>Public liability insurance</li>
        <li>Professional indemnity / malpractice insurance</li>
        <li>DBS certificate</li>
        <li>Council licence or exemption evidence (where relevant)</li>
        <li>Hygiene / equipment declaration</li>
      </ul>
      <p>
        While documents are pending, Partners may complete their profile but will
        not appear in customer search and cannot receive bookings until an admin
        approves the account.
      </p>

      <h2>5. Partner Responsibility and Limitation of Platform Liability</h2>
      <p>
        BeautyMateUK operates as a technology platform that enables Customers to
        discover, request, book, and pay for services provided by independent
        Partners. The Partner, and not BeautyMateUK, is responsible for performing
        the booked service with reasonable care and skill, using appropriate
        qualifications, hygiene standards, tools, products, and insurance.
      </p>
      <p>
        Each Partner is solely responsible for any injury, allergic reaction,
        treatment issue, loss, damage, property damage, or other claim arising
        from the Partner's acts, omissions, advice, products, equipment, hygiene
        practices, or performance of the service, except to the extent caused
        directly by BeautyMateUK's own negligence or breach of law.
      </p>
      <p>
        Partners must maintain appropriate insurance, including public liability
        insurance and, where relevant, professional indemnity, malpractice,
        treatment risk, and product liability cover. BeautyMateUK may request
        evidence of insurance at onboarding and at any time during the Partner's
        use of the Platform.
      </p>
      <p>
        Nothing in these Terms excludes or limits any liability that cannot
        legally be excluded or limited, including liability for death or personal
        injury caused by negligence, fraud, fraudulent misrepresentation, or any
        consumer rights that cannot be excluded under applicable law.
      </p>

      <h2>6. Commission</h2>
      <p>
        BeautyMateUK retains a 20% platform commission on the service price.
        Partners keep 80% of the service price plus 100% of the travel fee.
      </p>

      <h2>7. Termination</h2>
      <p>
        Either party may terminate at any time. BeautyMateUK may suspend or
        remove Partners who breach these Terms, applicable law, customer safety
        rules, or platform standards.
      </p>
    </LegalLayout>
  );
}
